import React from 'react';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import SubHeader from '../SubComp/SubHeader/SubHeader';
import './Feature.css'

const Features = () => {
    return (
        // Feature
        <div className="Feature bg_Dark">
            <Header />
            <SubHeader title="Features Art" text="Features" width='container' />
            <div className="newThisWeek bg_Dark">
                <div className="container py-5">
                    <h1 className='text-white bold mb-4'>New This Week</h1>
                    <div className="row">
                        <div className="col-lg-6 mb-4">
                            <div class="image_overlay cursor">
                                <img src={require('../../Asset/feature/demo-6.png')} alt="" />
                                <div class="image_overlay_content p-4">
                                    <h5 className="bold">Abacus Oil Painting</h5>
                                    <p>7 Jan, 2022</p>
                                    <div className="d-flex align-items-center">
                                        <div className="image_overlay_content_roundImage me-2">
                                            <img src={require('../../Asset/feature/artist_small.png')} alt="" />
                                        </div>
                                        <h6>John Albert</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 mb-4">
                            <div class="image_overlay cursor">
                                <img src={require('../../Asset/feature/demo-3.png')} alt="" />
                                <div class="image_overlay_content p-4">
                                    <h5 className="bold">Abacus Oil Painting</h5>
                                    <p>7 Jan, 2022</p>
                                    <div className="d-flex align-items-center">
                                        <div className="image_overlay_content_roundImage me-2">
                                            <img src={require('../../Asset/feature/artist_small.png')} alt="" />
                                        </div>
                                        <h6>John Albert</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 mb-4">
                            <div class="image_overlay cursor">
                                <img src={require('../../Asset/feature/demo-6.png')} alt="" />
                                <div class="image_overlay_content p-4">
                                    <h5 className="bold">Abacus Oil Painting</h5>
                                    <p>7 Jan, 2022</p>
                                    <div className="d-flex align-items-center">
                                        <div className="image_overlay_content_roundImage me-2">
                                            <img src={require('../../Asset/feature/artist_small.png')} alt="" />
                                        </div>
                                        <h6>John Albert</h6>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="col-lg-6 mb-4">
                            <div class="image_overlay cursor">
                                <img src={require('../../Asset/feature/demo-6.png')} alt="" />
                                <div class="image_overlay_content p-4">
                                    <h5 className="bold">Abacus Oil Painting</h5>
                                    <p>7 Jan, 2022</p>
                                    <div className="d-flex align-items-center">
                                        <div className="image_overlay_content_roundImage me-2">
                                            <img src={require('../../Asset/feature/artist_small.png')} alt="" />
                                        </div>
                                        <h6>John Albert</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 mb-4">
                            <div class="image_overlay cursor">
                                <img src={require('../../Asset/feature/demo-3.png')} alt="" />
                                <div class="image_overlay_content p-4">
                                    <h5 className="bold">Abacus Oil Painting</h5>
                                    <p>7 Jan, 2022</p>
                                    <div className="d-flex align-items-center">
                                        <div className="image_overlay_content_roundImage me-2">
                                            <img src={require('../../Asset/feature/artist_small.png')} alt="" />
                                        </div>
                                        <h6>John Albert</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 mb-4">
                            <div class="image_overlay cursor">
                                <img src={require('../../Asset/feature/demo-6.png')} alt="" />
                                <div class="image_overlay_content p-4">
                                    <h5 className="bold">Abacus Oil Painting</h5>
                                    <p>7 Jan, 2022</p>
                                    <div className="d-flex align-items-center">
                                        <div className="image_overlay_content_roundImage me-2">
                                            <img src={require('../../Asset/feature/artist_small.png')} alt="" />
                                        </div>
                                        <h6>John Albert</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="otherArtist bg_lightDark">
                <div className="container py-5">
                    <h1 className='text-white bold mb-4'>Other Artists</h1>
                    <div className="row justify-content-center">
                        <div className="col-lg-3 mb-4">
                            <div class="image_overlay cursor">
                                <img src={require('../../Asset/feature/demo-6.png')} alt="" />
                                <div class="image_overlay_content p-4">
                                    <h5 className="bold">Abacus Oil Painting</h5>
                                    <p>7 Jan, 2022</p>
                                    <div className="d-flex align-items-center">
                                        <div className="image_overlay_content_roundImage me-2">
                                            <img src={require('../../Asset/feature/artist_small.png')} alt="" />
                                        </div>
                                        <h6>John Albert</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 mb-4">
                            <div class="image_overlay cursor">
                                <img src={require('../../Asset/feature/demo-3.png')} alt="" />
                                <div class="image_overlay_content p-4">
                                    <h5 className="bold">Abacus Oil Painting</h5>
                                    <p>7 Jan, 2022</p>
                                    <div className="d-flex align-items-center">
                                        <div className="image_overlay_content_roundImage me-2">
                                            <img src={require('../../Asset/feature/artist_small.png')} alt="" />
                                        </div>
                                        <h6>John Albert</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 mb-4">
                            <div class="image_overlay cursor">
                                <img src={require('../../Asset/feature/demo-6.png')} alt="" />
                                <div class="image_overlay_content p-4">
                                    <h5 className="bold">Abacus Oil Painting</h5>
                                    <p>7 Jan, 2022</p>
                                    <div className="d-flex align-items-center">
                                        <div className="image_overlay_content_roundImage me-2">
                                            <img src={require('../../Asset/feature/artist_small.png')} alt="" />
                                        </div>
                                        <h6>John Albert</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 mb-4">
                            <div class="image_overlay cursor">
                                <img src={require('../../Asset/feature/demo-6.png')} alt="" />
                                <div class="image_overlay_content p-4">
                                    <h5 className="bold">Abacus Oil Painting</h5>
                                    <p>7 Jan, 2022</p>
                                    <div className="d-flex align-items-center">
                                        <div className="image_overlay_content_roundImage me-2">
                                            <img src={require('../../Asset/feature/artist_small.png')} alt="" />
                                        </div>
                                        <h6>John Albert</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 mb-4">
                            <div class="image_overlay cursor">
                                <img src={require('../../Asset/feature/demo-3.png')} alt="" />
                                <div class="image_overlay_content p-4">
                                    <h5 className="bold">Abacus Oil Painting</h5>
                                    <p>7 Jan, 2022</p>
                                    <div className="d-flex align-items-center">
                                        <div className="image_overlay_content_roundImage me-2">
                                            <img src={require('../../Asset/feature/artist_small.png')} alt="" />
                                        </div>
                                        <h6>John Albert</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 mb-4">
                            <div class="image_overlay cursor">
                                <img src={require('../../Asset/feature/demo-6.png')} alt="" />
                                <div class="image_overlay_content p-4">
                                    <h5 className="bold">Abacus Oil Painting</h5>
                                    <p>7 Jan, 2022</p>
                                    <div className="d-flex align-items-center">
                                        <div className="image_overlay_content_roundImage me-2">
                                            <img src={require('../../Asset/feature/artist_small.png')} alt="" />
                                        </div>
                                        <h6>John Albert</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer displayNone='d-none' />
        </div>
    );
};

export default Features;